<template>
  <div>
    <step-1 v-if="step == 1" :step="step" :sidebarListLinks="sidebarListLinks"></step-1>
    <step-2 v-else-if="step == 2" :step="step" :sidebarListLinks="sidebarListLinks"></step-2>
    <step-3 v-else-if="step == 3" :step="step" :sidebarListLinks="sidebarListLinks"></step-3>
  </div>
</template>

<script>
import Step1 from "./Step1.vue"
import Step2 from "./Step2.vue"
import Step3 from "./Step3.vue"
import Logout from "../../../../pages/common/Logout.vue";
export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      step: 1,
      sidebarListLinks: [
        { label: 'Create Account', routeTo: { name: 'register-manager', params: { step: 1 } }, disabled: true},
        { label: 'Business Details', routeTo: { name: 'register-manager', params: { step: 2 } }, disabled: true },
        { label: 'Terms and Conditions', routeTo: { name: 'register-manager', params: { step: 3 } }, disabled: true },
      ]
    }
  },
  mounted() {
    this.step = this.$route.params.step
  },
  methods: {
  },
  watch: {
    $route($to, $from) {
      if ($to.name == "register-manager") {
        this.step = $to.params.step
      }
    },
  },
}
</script>
